const sustainabilityMainWrap = () => import("@/views/main_wrap.vue");

const createSustainabilityViewRoute = ({ path, name, component, aliases = [], meta = {} }) => ({
    path,
    name,
    alias: aliases,
    meta,
    component: sustainabilityMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const sustainabilityRoutes = [
    createSustainabilityViewRoute({
        path: "/sustainability/overview",
        name: "Gsrsu0101",
        aliases: [
            "/gsrsu0101",
            "/gsrsu010201",
            "/gsrsu010202",
            "/gsrsu010203",
            "/gsrsu010204",
            "/gsrsu0102",
            "/sustainability/gsrsu0101",
            "/sustainability/gsrsu010201",
            "/sustainability/gsrsu010202",
            "/sustainability/gsrsu010203",
            "/sustainability/gsrsu010204",
            "/sustainability/gsrsu0102"
        ],
        component: () => import("@/views/sustainability/01/gsrsu0101.vue")
    }),
    createSustainabilityViewRoute({
        path: "/sustainability/environmental",
        name: "Gsrsu0201",
        aliases: [
            "/gsrsu0201",
            "/gsrsu020101",
            "/gsrsu020102",
            "/gsrsu020103",
            "/gsrsu02010301",
            "/gsrsu020104",
            "/sustainability/gsrsu0201",
            "/sustainability/gsrsu020101",
            "/sustainability/gsrsu020102",
            "/sustainability/gsrsu020103",
            "/sustainability/gsrsu02010301",
            "/sustainability/gsrsu020104"
        ],
        component: () => import("@/views/sustainability/02/gsrsu0201.vue")
    }),
    createSustainabilityViewRoute({
        path: "/sustainability/social-responsibility/win-win-activity",
        name: "Gsrsu0301010101",
        aliases: [
            "/gsrsu0301010101",
            "/sustainability/win-win-activity",
            "/sustainability/gsrsu0301010101"
        ],
        component: () => import("@/views/sustainability/03/gsrsu0301010101.vue")
    }),
    createSustainabilityViewRoute({
        path: "/sustainability/social-responsibility/win-win-activity/detail",
        name: "Gsrsu030101010101",
        aliases: [
            "/gsrsu030101010101",
            "/sustainability/win-win-activity/detail",
            "/sustainability/gsrsu030101010101"
        ],
        meta: {
            queryRules: {
                prrSeqno: { required: true, pattern: /^\d+$/ }
            }
        },
        component: () => import("@/views/sustainability/03/gsrsu030101010101.vue")
    }),
    createSustainabilityViewRoute({
        path: "/sustainability/social-responsibility/hidden-sharing-angel/detail",
        name: "Gsrsu0301010102",
        aliases: [
            "/gsrsu0301010102",
            "/sustainability/hidden-sharing-angel/detail",
            "/sustainability/gsrsu0301010102"
        ],
        meta: {
            queryRules: {
                hiddenSharingAngelSeqno: { required: true, pattern: /^\d+$/ },
                tab: { pattern: /^[a-z0-9-]+$/ },
                subTab: { pattern: /^[a-z0-9-]+$/ }
            }
        },
        component: () => import("@/views/sustainability/03/gsrsu0301010102.vue")
    }),
    createSustainabilityViewRoute({
        path: "/sustainability/social-responsibility/hidden-sharing-angel",
        name: "Gsrsu030205",
        aliases: [
            "/sustainability/hidden-sharing-angel"
        ],
        component: () => import("@/views/sustainability/03/gsrsu03010101.vue")
    }),
    createSustainabilityViewRoute({
        path: "/sustainability/social-responsibility",
        name: "Gsrsu03010101",
        aliases: [
            "/gsrsu03010101",
            "/gsrsu0301010201",
            "/gsrsu0301010202",
            "/gsrsu0301010203",
            "/gsrsu0301010205",
            "/gsrsu0301010401",
            "/gsrsu030201",
            "/gsrsu030202",
            "/gsrsu030203",
            "/gsrsu030204",
            "/gsrsu030205",
            "/gsrsu030301",
            "/gsrsu03030101",
            "/gsrsu03030201",
            "/gsrsu03030202",
            "/gsrsu03030203",
            "/gsrsu03030204",
            "/gsrsu030303",
            "/gsrsu03030301",
            "/gsrsu03030302",
            "/gsrsu0303030302",
            "/gsrsu0303030303",
            "/gsrsu0303030304",
            "/gsrsu0303030305",
            "/gsrsu0303030306",
            "/gsrsu03030304",
            "/gsrsu030304",
            "/gsrsu03030401",
            "/gsrsu030305",
            "/sustainability/gsrsu03010101",
            "/sustainability/gsrsu0301010201",
            "/sustainability/gsrsu0301010202",
            "/sustainability/gsrsu0301010203",
            "/sustainability/gsrsu0301010205",
            "/sustainability/gsrsu0301010401",
            "/sustainability/gsrsu030201",
            "/sustainability/gsrsu030202",
            "/sustainability/gsrsu030203",
            "/sustainability/gsrsu030204",
            "/sustainability/gsrsu030205",
            "/sustainability/gsrsu030301",
            "/sustainability/gsrsu03030101",
            "/sustainability/gsrsu03030201",
            "/sustainability/gsrsu03030202",
            "/sustainability/gsrsu03030203",
            "/sustainability/gsrsu03030204",
            "/sustainability/gsrsu030303",
            "/sustainability/gsrsu03030301",
            "/sustainability/gsrsu03030302",
            "/sustainability/gsrsu0303030302",
            "/sustainability/gsrsu0303030303",
            "/sustainability/gsrsu0303030304",
            "/sustainability/gsrsu0303030305",
            "/sustainability/gsrsu0303030306",
            "/sustainability/gsrsu03030304",
            "/sustainability/gsrsu030304",
            "/sustainability/gsrsu03030401",
            "/sustainability/gsrsu030305"
        ],
        meta: {
            queryRules: {
                tab: { pattern: /^[a-z0-9-]+$/ },
                subTab: { pattern: /^[a-z0-9-]+$/ }
            }
        },
        component: () => import("@/views/sustainability/03/gsrsu03010101.vue")
    }),
    createSustainabilityViewRoute({
        path: "/sustainability/compliance",
        name: "Gsrsu040101",
        aliases: [
            "/gsrsu040101",
            "/gsrsu040102",
            "/gsrsu04010201",
            "/gsrsu040103",
            "/gsrsu04020301",
            "/gsrsu04020302",
            "/gsrsu04020303",
            "/gsrsu04020304",
            "/sustainability/gsrsu040101",
            "/sustainability/gsrsu040102",
            "/sustainability/gsrsu04010201",
            "/sustainability/gsrsu04020301",
            "/sustainability/gsrsu04020302",
            "/sustainability/gsrsu04020303",
            "/sustainability/gsrsu04020304",
            "/sustainability/gsrsu040103"
        ],
        meta: {
            queryRules: {
                from: { values: ["customerCenter"] },
                ethicsInquiry: { values: ["1"] },
                tab: { pattern: /^[a-z0-9-]+$/ },
                subTab: { pattern: /^[a-z0-9-]+$/ }
            }
        },
        component: () => import("@/views/sustainability/04/gsrsu040101.vue")
    })
];
